module.exports = new __parcel__URL__("long.9af40e67.webp").toString();